"use client";

import Image from "next/image";
import { Check, RotateCcw } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PortraitLandmarks } from "@/components/home-visual";

// A visual API example, not a live inference request or an accuracy claim.
export default function FaceComparisonHero() {
  const [sequence, setSequence] = useState(0);
  return <figure className="comparison-demo" aria-label="Face comparison example">
    <div className="comparison-demo-head"><code>POST /verify</code><Button type="button" variant="ghost" size="sm" aria-label="Replay the comparison example" onClick={() => setSequence(value => value + 1)}><RotateCcw aria-hidden="true" />Replay</Button></div>
    <div key={sequence} className="comparison-sequence">
      <div className="comparison-inputs">
        {[{name:"Photo 1",src:"/samples/synthetic-portrait-v1.png",variant:"reference" as const},{name:"Photo 2",src:"/samples/synthetic-portrait-v3.png",variant:"second" as const}].map(photo => <div className="comparison-input" key={photo.name}><p>{photo.name}</p><div className="conversion-portrait"><Image src={photo.src} alt={`${photo.name} in the face comparison example`} width={1254} height={1254} sizes="(min-width: 768px) 230px, 45vw" priority /><PortraitLandmarks variant={photo.variant} /></div></div>)}
      </div>
      <div className="comparison-output"><div><span>Example response</span><p><Check aria-hidden="true" />Face match</p></div><code>{'{ "verified": true }'}</code></div>
    </div>
  </figure>;
}
